import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {quoteRequestNextStep, resetQuoteRequestPage } from "../../../store";
import QRSignupForm from "./QRSignupForm";
import Confirmation from "./Confirmation";
import { NavLink } from "react-router-dom";
import QRSignupFormRaffle from "./QRSignupFormRaffle";

const QRCodeForm = () => {
  const page = useSelector((state) => state.quoteRequestForm.page);
  const dispatch = useDispatch();
  
  let [lotteryResult, setLotteryResult] = useState('')

  const handleNextPage = () => {
    dispatch(quoteRequestNextStep());
  };

  useEffect(() => {
    dispatch(resetQuoteRequestPage(0))
  }, [])

  function showLotteryResult(x){
    // console.log("Result is: ", x);
    setLotteryResult(x)
    
  }


  const PageDisplay = () => {
    switch (page) {

      case 0:
		if(window.location.pathname.includes('raffle')){
			return (
				<QRSignupFormRaffle
				page={page}
				handleNextPage={handleNextPage}
				sendLotteryResult={showLotteryResult}
				/>
			);
		}
		else {
			return (
				<QRSignupForm
				page={page}
				handleNextPage={handleNextPage}
				sendLotteryResult={showLotteryResult}
			/>
			);
		}
      case 1:
        return <Confirmation page={page} lotteryResult={lotteryResult} />;
      default:
        break;
    }
  };

  return (
    <>
     <div className='flex justify-center'>
            <NavLink to='https://acgtinc.com/'
            target="_blank"
            >
                <img
                className='w-[250px] h-auto my-4'
                src='/images/acgt-logo-2022.png'
                alt='acgt-logo'
                />
            </NavLink>
        </div>
        <div className='border-2 border-[var(--color-primary-purple)] bg-[var(--color-primary-purple)] h-[30px]  '></div>

        {/* <p className="mt-12 text-2xl font-bold text-center">Invalid QR Code</p>
        <p className="mt-16 text-xl font-bold text-center">Please click on the link below <br/><br/> <a className="text-blue-500 underline" href="https://order.acgtinc.com/acgtQR">https://order.acgtinc.com</a></p> */}
      <PageDisplay />
    </>
  );
};

export default QRCodeForm;